import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {UpdatePassengerRequestType, UpdatePassengerResponseType} from "@CheckOrder/api/types/UpdatePassengerQuery.type";
import {addPassengerToResolvedList} from "@CheckOrder/reducers/checkOrderSlice";
import {setError} from "@Reducers/pageSlice";

export default function updatePassengerQuery(): OnQueryStartedFunctionAttrType<UpdatePassengerRequestType, UpdatePassengerResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        try {
            const response = await queryFulfilled

            if (response.meta.response.ok && response?.data?.data?.success) {
                // TODO remove this if unnecessary (where is the resolvedList used?)
                dispatch(addPassengerToResolvedList(response.data.data.passenger.passengerId))
            }
        } catch (err) {
            dispatch(setError({
                error: JSON.stringify(err),
                info: request.ticketCode,
            }))
        }
    }
}